module.exports = __webpack_public_path__ + "static/media/mobile-app-showcase.00d0793b.png";